import { render, staticRenderFns } from "./index4.vue?vue&type=template&id=2e5a8a42&scoped=true&"
import script from "./index4.vue?vue&type=script&lang=js&"
export * from "./index4.vue?vue&type=script&lang=js&"
import style0 from "./index4.vue?vue&type=style&index=0&id=2e5a8a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5a8a42",
  null
  
)

export default component.exports